module.exports = __webpack_public_path__ + "static/media/Blog post-rafiki.5ded9c52.svg";